import { useQuery } from "@tanstack/react-query"
import authGet from "../methods/authGet"
import AppUrls from "../endpoint/app"

export const GET_AUTH_CONFIG = "GET_AUTH_CONFIG"

let _invalidateConfig = null

export function subscribeGetConfig(refresh) {
  _invalidateConfig = refresh
}

export function refreshAuthConfig() {
  if (_invalidateConfig) _invalidateConfig()
}

export const useGetAuthConfig = () =>
  useQuery({
    queryKey: [GET_AUTH_CONFIG],
    queryFn: () => authGet({ url: AppUrls.getConfig }),
    select: (res) => res?.data,
    // App selalu mounted → observer tunggal; komponen route lain berbagi cache
    // tanpa refetch (staleTime global 0 akan memicu refetch ganda saat lazy-route mount).
    // Refresh eksplisit tetap lewat refreshAuthConfig() → invalidateQueries.
    refetchOnMount: false,
    refetchOnReconnect: false
  })

export const useAppConfig = () => {
  const { data } = useGetAuthConfig()
  return {
    userDetails: data?.user_details ?? {},
    userPermissions: data?.user_permissions ?? [],
    providerDetails: data?.provider_details ?? {},
    slab: data?.slab || {}
  }
}
